class OgrnIpValidator {
	regexp = /^([0-9]{15})$/;
	message = '';

	validate = (value: string): boolean => {
		this.message = 'Поле должно содержать 15 цифр';
		if (!this.regexp.test(value)) {
			return false;
		}

		const val = parseInt(value.substring(0, 14));
		const checksum = parseInt(value[14]);

		this.message = 'Некорректный ОГРН';
		return (val % 13) % 10 === checksum;
	};
}

export default OgrnIpValidator;
